import AxiosClient from '../../../services/axios.services';

class WorkFlowServices {
  getWorkFlows = params => AxiosClient.get('/api/app/On_off_bording_workflow_plantilla/', {
    headers: {'Content-Type': 'application/json'},
    params: params
  });
  
  getWorkFlow = id => AxiosClient.get(`/api/app/On_off_bording_workflow_plantilla/${id}`,{
    headers: {'Content-Type': 'application/json'}
  });

  saveWorkflow = data => AxiosClient.post('/api/app/On_off_bording_workflow_plantilla/', data, {
    headers: {'Content-Type': 'application/json'}
  });

  copyWorkflow = data => AxiosClient.post('/api/app/On_off_bording_workflow_duplicar/', data, {
    headers: {'Content-Type': 'application/json'}
  });

  editWorkFlow = (id, data) => AxiosClient.put(`/api/app/On_off_bording_workflow_plantilla/${id}/`, data, {
    headers: {'Content-Type': 'application/json'}
  });

  deleteWorkFlow = id => AxiosClient.delete(`/api/app/On_off_bording_workflow_plantilla/${id}/`, {
    headers: {'Content-Type': 'application/json'}
  });  
}

export default new WorkFlowServices();